import PropTypes from 'prop-types'

export const TeamMemberCard = ({ name, role, image, description = [] }) => (
  <div className="bg-dark-secondary rounded-lg p-6 border border-dark-border">
    {image && (
      <div className="mb-4">
        <img src={image} alt={name} className="w-full h-96 object-cover object-top rounded-lg" />
      </div>
    )}

    <h3 className="text-xl font-bold text-white mb-1">{name}</h3>
    <p className="text-sm text-gray-400 mb-4">{role}</p>

    <div className="space-y-3">
      {description.map((paragraph, index) => (
        <p key={index} className="text-gray-300 text-sm">
          {paragraph}
        </p>
      ))}
    </div>
  </div>
)

TeamMemberCard.propTypes = {
  name: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired,
  image: PropTypes.string,
  description: PropTypes.arrayOf(PropTypes.string),
}

export default TeamMemberCard
